// extracted by mini-css-extract-plugin
module.exports = {"container":"_772e1b1e50--container--ScGra","image":"_772e1b1e50--image--lULBD","content":"_772e1b1e50--content--UWbHN","button-wrapper":"_772e1b1e50--button-wrapper--Fw4qp"};